export default "__VITE_ASSET__DsdcdvtS__"